import { HStack, Pressable, VStack } from 'native-base';
import React, { ReactNode, useState } from 'react';
import { Caption } from './Typography';
import { useShopStyles } from './styles';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { SpIcon } from './Icon';

export type SBDropdownProp = {
    title?: string;
    children?: ReactNode;
    defaultShowChildren?: boolean;
    value?: string | number;
    isV2?: boolean;
};

export const SBDropdown = ({
    title,
    children,
    defaultShowChildren = false,
    value,
    isV2 = false
}: SBDropdownProp) => {

    const { icon, pressable_text, text, section_background } = useShopStyles();
    const [showChildren, setShowChildren] = useState(defaultShowChildren);

    return (
        <VStack space={1} w={'100%'}>
            <HStack alignItems={'center'} justifyContent={'space-between'} space={isV2 ? 0 : 1}>
                <Pressable
                    onPress={() => setShowChildren(!showChildren)}
                    bg={section_background}
                    py={1}
                    px={2}
                    borderRadius={isV2 ? 0 : 4}
                    flex={1}
                    size={8}
                >
                    <Caption color={value ? pressable_text : text }>
                        { value ? value : title }
                    </Caption>
                </Pressable>
                <Pressable
                    onPress={() => setShowChildren(!showChildren)}
                    bg={section_background}
                    px={2}
                    justifyContent={'center'}
                    borderRadius={isV2 ? 0 : 4}
                    size={8}
                >
                    <SpIcon icon={showChildren ? faAngleUp : faAngleDown} color={icon}/>
                </Pressable>
            </HStack>
            { showChildren ? children : <></> }
        </VStack>
    );
};
